import { render } from "./AddSecteurModal.vue?vue&type=template&id=8c54476e&ts=true"
import script from "./AddSecteurModal.vue?vue&type=script&lang=ts"
export * from "./AddSecteurModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__